import { render, staticRenderFns } from "./exportItemsComponent.vue?vue&type=template&id=83e684a2&"
import script from "./exportItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./exportItemsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports